import { paletteBase } from '@abg/kit-base';
import { AbgSxProps } from '@abg/typings';

import {
  CarInfoAccordionStyleParts,
  CarInfoAccordionWrapperStyling,
  CarInfoSummaryStyling,
} from './car-info-accordion.types';

export const carInfoAccordionWrapperStyling: CarInfoAccordionWrapperStyling =
  (styleParts) => (theme) => ({
    zIndex: 1,
    maxHeight: 'calc(95vh - 120px)',
    width: '100%',
    position: 'absolute',
    bottom: '100%',
    left: '50%',
    transform: 'translate(-50%, 0%)',
    borderRadius: '4px',
    overflowY: 'auto',
    backgroundColor: 'white',
    [theme.breakpoints.down(480)]: {
      borderRadius: '4px 4px 0 0',
      marginTop: '-8px',
    },
    ...styleParts,
  });

export const carInfoAccordionStyling: CarInfoAccordionStyleParts = {
  rateTerms: {
    fontSize: '12px',
    lineHeight: '13px',
    fontWeight: 400,
    textDecoration: 'underline',
    color: paletteBase.neutral400,
  },
  divider: { margin: '22px 24px 20px 24px' },
  headerContainerGutter: {
    padding: '12px 24px',
  },
  headerText: {
    marginBottom: '5px',
  },
  headerImageContainer: {
    width: 'auto',
  },
  accordion: {
    '&.Custom-Mui-Accordion-class.MuiPaper-root': {
      borderRadius: 'initial',
      width: '100%',
      borderBottom: 0,
      boxShadow: 'none',
      '&:last-child': { marginBottom: '20px' },
    },
    '&::before': {
      display: 'none',
    },
    '&.disable-click.MuiPaper-root': {
      pointerEvents: 'none',
    },
  },
  accordionSummary: {
    '&.Custom-Mui-Accordion-summary-class.MuiButtonBase-root': {
      padding: '4px 24px',
      minHeight: 'initial',
      touchAction: 'manipulation',
      '&:hover': {
        background: paletteBase.neutralGrey200,
      },
    },
    '&.MuiButtonBase-root.active-summary': {
      background: paletteBase.neutralGrey200,
    },
    '& .MuiAccordionSummary-content': {
      margin: 0,
      display: 'flex',
      flexDirection: 'column',
    },
    '& .MuiTypography-root': {
      lineHeight: '20px',
    },
  },
  accordionDetails: {
    padding: '4px 24px',
  },
  caret: { width: '12px', height: '12px' },
  subText: {
    padding: { xs: '0', sm: '0px 24px' },
    color: paletteBase.secondary400,
  },
};

export const carInfoSummaryStyling: CarInfoSummaryStyling = {
  headerTextStyles: { fontWeight: 500 },
  recentCostStyles: { fontWeight: 500 },
  previousCostStyles: { textDecoration: 'line-through' },
};

export const checkoutMobileAccordionSummaryStyling: AbgSxProps = {
  '& .MuiAccordionSummary-expandIconWrapper': {
    ml: { xs: '8px', sm: 0 },
  },
  '&.MuiButtonBase-root.active-summary': {
    background: 'transparent !important',
  },
  '&.MuiButtonBase-root': {
    padding: '0px !important',
    touchAction: 'manipulation',
    '&:hover': {
      background: 'transparent !important',
    },
  },
};

export const checkoutMobileCommonText: AbgSxProps = {
  fontWeight: 400,
  fontSize: '14px !important',
};

export const checkoutMobileAccordionStyling: AbgSxProps = {
  '&.Custom-Mui-Accordion-class.MuiPaper-root': {
    borderRadius: 'initial',
    width: '100%',
    borderBottom: 0,
    boxShadow: 'none',
    marginTop: '16px',
    '&:last-child': { marginBottom: 0 },
    '&:first-child': { marginTop: 0 },
  },
};

export const checkoutMobileAccordionDetailsStyling: AbgSxProps = {
  padding: 0,
};

export const qantasBannerContainer: AbgSxProps = {
  display: 'flex',
  marginInline: { xs: '0px', md: '24px' },
  marginBlock: '16px',
  border: '1px solid #736D6D4D',
  borderRadius: '4px',
  backgroundColor: '#F4F4F4',
  padding: '16px',
  gap: '8px',
};

export const qantasBannerText: AbgSxProps = {
  fontSize: { xs: '14px', md: '16px' },
  fontWeight: 700,
};

export const qantasBannerSubText: AbgSxProps = {
  fontSize: { xs: '12px !important', md: '14px !important' },
  fontWeight: 400,
};
